import { render, staticRenderFns } from "./contactInformation.vue?vue&type=template&id=10bf9599&scoped=true&"
import script from "./contactInformation.vue?vue&type=script&lang=js&"
export * from "./contactInformation.vue?vue&type=script&lang=js&"
import style0 from "./contactInformation.vue?vue&type=style&index=0&id=10bf9599&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bf9599",
  null
  
)

export default component.exports